import {useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CustomCheckbox from '../common/CustomCheckbox';
import FormInput from '../common/FormInput';
import ProviderAvatar from '../providers/ProviderAvatar';
import { useSignupLeadMutation } from '../../redux/services/leadApi';
import { formatProviderName } from '../../helpers/providers';

const formFields = () => [
  {
    name: 'contact_first_name',
    label: 'First Name',
    type: 'text',
    placeholder: 'Jane',
    required: true,
    fullWidth: true,
    eventTypes: ['THIRTY_FOR_THIRTY'],
    grid: {
      xs: 12,
      md: 6,
    },
  },
  {
    name: 'contact_last_name',
    label: 'Last Name',
    type: 'text', 
    placeholder: 'Smith',
    required: true,
    fullWidth: true,
    eventTypes: ['THIRTY_FOR_THIRTY'],
    grid: {
      xs: 12,
      md: 6,
    },
  },
  {
    name: 'contact_email',
    label: 'Email',
    type: 'email',
    placeholder: 'jane.smith@example.com',
    required: true,
    eventTypes: ['THIRTY_FOR_THIRTY'],
    fullWidth: true,
    grid: {
      xs: 12,
      md: 12,
    },
  },
  {
    name: 'contact_phone',
    label: 'Phone Number',
    type: 'phone',
    placeholder: '(555) 555-5555',
    required: false,
    eventTypes: [],
    grid: {
      xs: 12,
      md: 6,
    },
  }
];

const handleFieldUpdate = ({formValues, setFormValues}) => name => (e, val) => {
  const value = val ? val: e.target.value;
  setFormValues({
    ...formValues,
    [name]: value,
  });
};

const handleSubmit = ({formValues, post}) => async e => {
  console.log('formValues', formValues);
  const response = await post(formValues);
};

const LeadEventSignupScreen = props => {
  const {providerId, eventType, provider} = props;
  console.log('LeadEventSignupScreen props', props);
  const [formValues, setFormValues] = useState({
    event_type: eventType,
    provider_id: providerId,
    contact_first_name: '',
    contact_last_name: '',
    contact_email: '',
  });
  const [post, response] = useSignupLeadMutation();
  const fields = formFields();
  const eventName = eventType === 'THIRTY_FOR_THIRTY' ? '30-for-30' : eventType;
  return (
    <Box 
      style={{
        paddingTop: '2rem', 
        paddingBottom: '2rem', 
        backgroundColor: '#F9F9F9',
        height: '100vh',
      }}
    >
      <Container maxWidth='xs' justifyContent='center' alignItems='center' style={{minHeight: '80vh'}}>
        <Paper>
          <Grid container spacing={1} padding={2}>
            <Grid item xs={12} md={12}>
              <Stack direction='row' spacing={2} marginBottom={2}>
                <ProviderAvatar provider={provider} size={100} />
                <Stack>
                  <Typography variant='h2'>
                    {formatProviderName(provider)}
                  </Typography>
                  {eventType && 
                    <Typography variant='body1' color='grey' fontWeight={500}>
                      Signup for {eventName} event
                    </Typography>
                  }
                </Stack>
              </Stack>
            </Grid>
            {!response.isSuccess ? <>
              {fields
                .filter(f => f.eventTypes.includes(eventType))
                .map(f => (
                <Grid item xs={f?.grid?.xs || 12} md={f?.grid?.md || 12} key={f.name}>
                  <FormInput
                    key={f.name}
                    {...f}
                    defaultValue={f.defaultValue}
                    onChange={handleFieldUpdate({formValues, setFormValues})(f.name)}
                    formValues={formValues}
                  />
                </Grid>
              ))}
              {/* {eventType === 'THIRTY_FOR_THIRTY' &&
                <Grid item xs={12} md={12} marginTop={2} marginBottom={2}>
                  <CustomCheckbox
                    label={<>
                      I agree to the <a href='#'>Treatment Consent</a>.
                    </>}
                    checked={formValues.consent || false}
                    onChange={(e) => {
                      setFormValues({
                        ...formValues,
                        consent: e.target.checked,
                      });
                    }}
                  />
                </Grid>
              } */}
              <Grid item xs={12} md={12} justifyContent='center'>
                <Stack direction='row' justifyContent='center' sx={{width: '100%'}}>
                  <Button 
                    variant='gradient' 
                    color='primary' 
                    onClick={handleSubmit({formValues, post})}
                  >
                    Submit
                  </Button>
                </Stack>
              </Grid>
            </>
            :
              <Grid item xs={12} md={12} justifyContent='center'>
                <Stack direction='column' justifyContent='center' alignItems='center' sx={{width: '100%'}} spacing={2} padding={4}>
                  <Typography variant='h3' align='center'>
                    Thank you for signing up!
                  </Typography>
                  <Typography variant='body1' align='center'>
                    We have received your information and will be in touch soon.
                  </Typography>
                </Stack>
              </Grid> 
            }
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default LeadEventSignupScreen;